var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5146 9.35645L12.5039 0.977539C12.5039 0.429688 12.1494 0.0429688 11.5693 0.0429688H3.19043C2.65332 0.0429688 2.28809 0.461914 2.28809 0.923828C2.28809 1.38574 2.69629 1.7832 3.1582 1.7832H5.63965L9.89355 1.63281L8.27148 3.01855L0.268555 11.043C0.0966797 11.2148 0 11.4404 0 11.6445C0 12.1064 0.418945 12.5576 0.902344 12.5576C1.12793 12.5576 1.34277 12.4717 1.51465 12.2998L9.52832 4.27539L10.9355 2.65332L10.7529 6.875V9.39941C10.7529 9.85059 11.1611 10.2803 11.6338 10.2803C12.0957 10.2803 12.5146 9.88281 12.5146 9.35645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonal);
export default __webpack_public_path__ + "static/media/arrow_diagonal.8423817c1de2fb1f19d65a6c386d789c.svg";
export { ForwardRef as ReactComponent };